import React from "react";
import emblem from "../../assets/img/image1.png";
import ecitizenLogo from "../../assets/img/image2.png";
import svg43 from "../../assets/svg/svg43.svg";

const items = [
  {
    title: "SDI",
    subTitle: "Registered Irrigation Service Providers",
    total: 17,
    svg: "emblem",
  },
  {
    title: "NHWSA",
    subTitle: "Water Harvesting and Storage Data and Information",
    total: 17,
    svg: "emblem",
  },
  {
    title: "Lands",
    subTitle: "Land Degradation Mapping and Assessment",
    total: 17,
    svg: "emblem",
  },

  {
    title: "County Govts",
    subTitle: "CIDU’s Irrigation Training Matters",
    total: 17,
    svg: "emblem",
  },
  {
    title: "NIA",
    subTitle: "Technical Advisory Services",
    total: 17,
    svg: "emblem",
  },
];
function Ecitizen() {
  const svgMap = {
    emblem,
  };
  const processedData = items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
  }));
  return (
    <div className="lg:min-h-[88vh] flex flex-col ">
        <img className="w-[10.8125rem] h-[2.75rem]" src={ecitizenLogo} alt="ecitizenLogo"/>
      <div className="white_card mt-[1.25rem] flex flex-1">
        <div className="form-add-h">All your government records unified</div>

        <div className="flex flex-shrink flex-wrap gap-[1.75rem] w-full mt-[1.25rem]">
          {processedData &&
            processedData?.map((item) => (
              <div className="border border-[#D6E1F5] rounded-[.75rem] lg:w-[20.125rem] w-full p-[1.25rem] bg-[#F7F7F7]">
               <div className="flex gap-x-[1rem]">
                <div className="flex justify-center items-center ">
                    <div className="w-[4.6875rem] h-[4.6875rem] flex justify-center items-center bg-white rounded-full">
                    <img src={item?.svg} alt={item?.svg}/>
                    </div> 
                </div>

                <div className="flex flex-col gap-y-[1.5rem]">
                <div className="flex items-center justify-between">
                <span className="text-[#424242] text-[.875rem] font-[400] font-interSans">
                  {item?.title}
                </span>
                <span className="flex items-center gap-x-[.65rem] text-[#0092CC] text-[.75rem] font-[500] font-interSans">
                  Go
                  <img src={svg43} alt="svg43" />
                </span>
                </div>

                <div className="flex items-center justify-between">
                <span
                  className="text-[#050505] text-[.875rem] font-interSans font-[500] overflow-hidden"
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 3, 
                    flex: "1 0 0",
                  }}
                >
                  {item?.subTitle}
                </span>
                <span className="text-[#050505] text-[1.5rem] font-interSans font-[500]">
                  {item?.total}
                </span>
                </div>
                </div> 

               </div> 
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default Ecitizen;
